import { Navigate, Outlet, useLocation } from "react-router";
import { useAceAccountManagement } from "../../hooks/ace/ace-account-management-provider";
import { paths } from "../../paths";
import { useEffect, useState } from "react";
import { useCountries } from "../../hooks/ace/use-countries";

export const OnboardingGuard = () => {
  const { profileData, kycData, currentToken } = useAceAccountManagement();
  const { isBlacklisted, isCountryRestrictionsAccepted } = useCountries();
  const [hasAcceptedCountryRestrictions, setHasAcceptedCountryRestrictions] =
    useState(false);

  const location = useLocation();
  const hasCompletedCountrySelection = profileData?.country;
  const hasCompletedAccountTypeSelection = kycData?.type;
  const hasCompletedClientCategorization = profileData?.clientCategorisation;

  useEffect(() => {
    const getCountryAcceptance = async () => {
      const result = await isCountryRestrictionsAccepted(currentToken);
      setHasAcceptedCountryRestrictions(result);
    };

    getCountryAcceptance();
  }, [currentToken, isCountryRestrictionsAccepted]);

  // blacklisted user redirect to country selection for countdown
  if (
    location.pathname !== paths.countrySelection &&
    profileData?.country &&
    isBlacklisted(profileData?.country)
  ) {
    return <Navigate to={paths.countrySelection} replace />;
  }

  if (
    location.pathname === paths.countrySelection &&
    !isBlacklisted(profileData?.country) &&
    hasCompletedCountrySelection &&
    hasAcceptedCountryRestrictions
  ) {
    return <Navigate to={paths.accountOverview} replace />;
  }

  if (
    location.pathname === paths.accountTypeSelection &&
    hasCompletedAccountTypeSelection
  ) {
    return <Navigate to={paths.accountOverview} replace />;
  }

  if (
    location.pathname === paths.accountTypeSelection &&
    !hasCompletedCountrySelection &&
    !hasAcceptedCountryRestrictions
  ) {
    return <Navigate to={paths.accountOverview} replace />;
  }

  if (
    location.pathname === paths.clientCategorisation &&
    hasCompletedClientCategorization
  ) {
    return <Navigate to={paths.accountOverview} replace />;
  }

  if (
    location.pathname === paths.restrictedInvestor &&
    hasCompletedClientCategorization
  ) {
    return <Navigate to={paths.accountOverview} replace />;
  }

  return <Outlet />;
};
